var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Session from '../../../services/Session';
import Routes from '../../../routes/RoutesConfig';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';
import FormField from '../../components/ui/FormField/FormField';
import AddUserToOrganisationCommand from '../../../commands/users/AddUserToOrganisationCommand';
import LogoutCommand from '../../../commands/authentication/LogoutCommand';
import GetCurrentUserCommand from '../../../commands/users/GetCurrentUserCommand';
import withRouter from "../../components/ui/MainNavigation/withRouter";
/**
 *
 */
var OnBoarding = /** @class */ (function (_super) {
    __extends(OnBoarding, _super);
    /**
     *
     */
    function OnBoarding(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            organisationName: '',
            submitting: false
        };
        _this.onLogout = _this.onLogout.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        console.log("Constructor on boarding");
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    OnBoarding.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     * @returns {*}
     */
    OnBoarding.prototype.render = function () {
        return (React.createElement(Page, { pageName: "on-boarding", className: "bg-primary" },
            React.createElement("div", { className: "container vh-100 align-items-center" },
                React.createElement("div", { className: "row h-75 justify-content-center align-items-center flex-column" },
                    React.createElement("img", { src: "/assets/images/logo-link-bi-white.svg", alt: "Link BI", className: "w-25 mb-5" }),
                    React.createElement("div", { className: "col-md-6 col-lg-5 card border-0 bg-transparent text-white", style: { fontSize: "larger" } },
                        React.createElement("h2", { className: "card-header align-items-center justify-content-center" },
                            React.createElement(FormattedMessage, { id: "onboarding.title" })),
                        React.createElement("div", { className: "mt-3" },
                            React.createElement("p", { className: "" },
                                React.createElement(FormattedHTMLMessage, { id: "onboarding.intro", values: Object(Session.user) })),
                            React.createElement("hr", null),
                            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                                React.createElement(Form, { onSubmit: this.onSubmit },
                                    React.createElement("fieldset", { disabled: this.state.submitting },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col text-white text-center" },
                                                    React.createElement(Label, { for: "organisationName" },
                                                        React.createElement(FormattedMessage, { id: "onboarding.field.organisationname" })))),
                                            React.createElement(FormField, null,
                                                React.createElement(Input, { name: "organisationName", id: "organisationName", onChange: this.onInputChange, required: true }))),
                                        React.createElement(Button, { className: "w-100 mb-3", color: "dark", type: "submit" },
                                            React.createElement(FormattedMessage, { id: "onboarding.createorganisation" })),
                                        React.createElement("p", { className: "text-center" },
                                            React.createElement("small", { className: "text-white text-center" },
                                                React.createElement(FormattedMessage, { id: "onboarding.wrongaccount" }),
                                                " ",
                                                React.createElement("a", { href: "#", onClick: this.onLogout, className: "text-white", style: { textDecoration: "underline" } },
                                                    React.createElement(FormattedMessage, { id: "onboarding.logout" })),
                                                ".")))))))))));
    };
    /**
     *
     * @param event
     */
    OnBoarding.prototype.onLogout = function (event) {
        event.preventDefault();
        var command = new LogoutCommand();
        command.execute();
    };
    /**
     *
     * @param e
     */
    OnBoarding.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };
    /**
     *
     * @param event
     */
    OnBoarding.prototype.onSubmit = function (event) {
        event.preventDefault();
        if (this.state.submitting) {
            return;
        }
        var intl = this.props.intl;
        var command = new AddUserToOrganisationCommand();
        command.execute(this.state['organisationName'], intl).then(this.onSuccess).catch(this.onError);
        this.setState({ errors: null, submitting: true });
    };
    /**
     *
     * @param response
     */
    OnBoarding.prototype.onSuccess = function (response) {
        var _this = this;
        // Update user to get organisation
        var command = new GetCurrentUserCommand();
        command.execute().then(function () {
            _this.props.router.navigate(Routes.ASSETS.getPath());
        }).catch(this.onError);
    };
    /**
     *
     * @param error
     */
    OnBoarding.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    return OnBoarding;
}(React.Component));
OnBoarding.contextType = ApplicationContext;
export default injectIntl(withRouter(OnBoarding));
